import * as _ from "lodash";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

import { Button, WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import Screen from "./Screen";
import { screens } from "./screen-images";

type ClassNames = "screens" | "filters" | "selected";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    filters: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        margin: theme.spacing.unit * 2
    },
    selected: {
        color: "white"
    },
    screens: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        flexWrap: "wrap",
        marginLeft: "10%",
        marginRight: "10%"
    }
});

type Kit = "All" | "Food" | "Social" | "Music" | "Photography" | "Travel";
const kits = {
    "All": "#73C700",
    "Food": "#73C700",
    "Social": "#A237F3",
    "Music": "#00A5FF",
    "Photography": "#FD4176",
    "Travel": "#FF9300",
    "Login": "#00A5FF"
};

interface ScreensProps {
    noop?: boolean
}

@observer
class Screens extends React.Component<WithStyles<ClassNames> & ScreensProps> {

    @observable public selected: Kit = "All";

    @action public select(kit: Kit) {
        this.selected = kit;
    }

    public render() {
        const {selected} = this;
        const {classes} = this.props;
        return (
            <div>
                <div className={classes.filters}>
                {
                    _.map(kits, (color: string, kit: Kit) => (
                        <Button
                            key={kit}
                            style={kit === selected ? { backgroundColor: color } : {}}
                            className={kit === selected ? classes.selected : ""}
                            {...{ onClick: () => this.select(kit)}}
                        >
                        {kit}
                        </Button>
                    ))
                }
                </div>
                <div className={classes.screens}>
                {
                    screens.map(screen => (
                        <Screen
                            style={(selected !== "All" && selected !== screen.kit) ? { display: "none" } : {}}
                            key={screen.id}
                            {...screen}
                        />
                    ))
                }
                </div>
            </div>
        );
    }
}

export default withStyles(styles)<ScreensProps>(Screens);



// WEBPACK FOOTER //
// ./src/elements/Screens.tsx